export enum ENTITY_TYPE {
  API = "API",
  ACTION = "ACTION",
  WIDGET = "WIDGET",
  GLOBAL = "GLOBAL",
  THEME = "THEME",
  ICONS = "ICONS",
  EMBEDDING = "EMBEDDING",
  EMBED_PROP = "EMBED_PROP",
  NESTED_ITEM = "NESTED_ITEM",
}
